/**
 * Gets an environment variable value.
 * Priority:
 *   1. Runtime config (window.__RUNTIME_CONFIG__)
 *   2. Vite build-time env (import.meta.env)
 *   3. Fallback default (if provided)
 */

interface WindowWithRuntimeConfig extends Window {
  __RUNTIME_CONFIG__?: Record<string, string>;
}

type ViteEnvRecord = Record<string, string>;

export enum AppEnvironment {
  Production = "production",
  Development = "development",
}

function getEnv(key: string, fallback?: string): string {
  //Runtime vars (injected via config.js)
  const runtimeConfig = (window as WindowWithRuntimeConfig).__RUNTIME_CONFIG__;
  const runtime = runtimeConfig?.[key];
  if (runtime) return runtime;
  //Build-time vars (Vite)
  const viteEnv = import.meta.env as unknown as ViteEnvRecord;
  const vite = viteEnv?.[key];
  if (vite) return vite;

  //Fallback (for local/dev)
  if (fallback !== undefined) return fallback;

  //Warn and return empty string if missing
  console.warn(`[env] Missing environment variable: ${key}`);
  return "";
}

export const env = {
  apiBaseUrl: getEnv("VITE_API_BASE_URL"),
  encryptionKey: getEnv("VITE_API_ENCRYPTION_KEY", "defaultKey"), // fallback helps in local dev
  sentryDsn: getEnv("VITE_SENTRY_DSN"),
  environment: getEnv("VITE_ENVIRONMENT", "production"),
};

export { getEnv };
